module.exports = __webpack_public_path__ + "92112b6dfc5f2346173c4bdaa7c66d7a.svg";